<div class="box align-left" [style.maxWidth]="maxWidth">
  <mat-icon class="my-2 ml-2 mr-1">info_outline</mat-icon>
  <p class="text letter-spacing">{{ text }}</p>
  <ng-content></ng-content>
</div>
